import { CloseRounded } from '@mui/icons-material'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField, Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { FormEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { updateAliasResource } from '../../../../../redux/actions/resources'
import SlideUpTransition from '../../../../shared/components/animations/SlideUpTransition'
import { CancelButton, SaveButton } from '../../../../shared/components/inputs'
import UpdateTitleLoading from './UpdateTitleLoading'

function UpdateTitleModal({ open, resource, onClose }: { open: boolean; resource: any; onClose: () => void }) {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()

  const [newTitle, setNewTitle] = useState(resource?.title || '')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const trimmedTitle = newTitle.trim()
    if (!trimmedTitle) {
      setError(t('title-required'))
      return
    }

    setError('')
    setLoading(true)

    try {
      if (resource?.id) {
        dispatch(updateAliasResource({ id: resource?.id, newAlias: trimmedTitle }))
        onClose()
      }
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Dialog open={open} fullWidth maxWidth="sm" TransitionComponent={SlideUpTransition} onClose={onClose}>
        <DialogTitle id={'dialog-update-alias-title'}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h6">{t('modify-title')}</Typography>
            <IconButton onClick={onClose} size="small">
              <CloseRounded />
            </IconButton>
          </Grid>
        </DialogTitle>

        <form onSubmit={handleSubmit}>
          <DialogContent>
            <TextField
              fullWidth
              label={t('title')}
              variant="filled"
              value={newTitle}
              onChange={e => {
                setNewTitle(e.target.value)
                setError('')
              }}
              placeholder={resource?.title || ''}
              error={!!error}
              helperText={error}
              required
            />
          </DialogContent>

          <DialogActions>
            <CancelButton onClick={onClose}>{t('cancel')}</CancelButton>
            <SaveButton type="submit" disabled={loading}>
              {t('save')}
            </SaveButton>
          </DialogActions>
        </form>
      </Dialog>

      <UpdateTitleLoading open={loading} />
    </>
  )
}

export default UpdateTitleModal
